<script setup lang="ts">
import { onMounted, ref } from "vue";

const props = defineProps<{
  kind: "success" | "error";
  message: string;
  autoDismissMs?: number;
}>();
const emit = defineEmits<{ (e: "dismiss"): void }>();
const visible = ref(true);

function dismiss() {
  visible.value = false;
  emit("dismiss");
}

onMounted(() => {
  if (props.kind === "success") {
    const t = props.autoDismissMs ?? 3000;
    setTimeout(dismiss, t);
  }
});
</script>

<template>
  <div
    v-if="visible"
    @click="dismiss"
    class="fixed top-4 right-4 max-w-sm rounded-lg px-4 py-3 shadow-lg ring-1 cursor-pointer z-50 font-medium"
    :class="props.kind === 'success' ? 'bg-emerald-500 text-white ring-emerald-600/30' : 'bg-red-500 text-white ring-red-600/30'"
    role="status"
  >
    {{ props.message }}
  </div>
</template>
